// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a56853d","453":"df7eb989","455":"3d4d7858","644":"fcb8db11"}[chunkId] + ".chunk.js";
};